import clsx from "clsx";

import LoadingSpinner from "~/components/LoadingSpinners/LoadingSpinner";

type Props = {
	/**
	 * `figure` is the value line of a figure row, `line` is a `text-sm` line inside a text, and `sm` is a `text-sm` line (20 px), as on the cards. A card value
	 * is short and sits at the right end of its row, so the `sm` box has no minimum width, and the spinner sits
	 * in the middle of where the value shows.
	 */
	size?: "figure" | "sm" | "line";
	/** The width class of a `line` box, near the width of the value, so a line does not move when the value arrives. */
	className?: string;
};

// The box has the height of the value line (for `figure`, 28 px on a phone and 24 px from `lg`) and a minimum
// width, so a row does not jump when the value arrives.
export function LoadingValue({ size = "figure", className }: Props) {
	return (
		<span className={clsx(
			"items-center justify-center",
			size === "line" ? "inline-flex h-5 align-middle" : "flex",
			size === "figure" && "min-h-7 min-w-12 lg:min-h-6",
			size === "sm" && "h-4",
			className,
		)}>
			<LoadingSpinner size="sm" theme="neutral" />
		</span>
	);
}
